import script from "./FormSuratPengesahanPenunjukanPJO.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSuratPengesahanPenunjukanPJO.vue?vue&type=script&setup=true&lang=js"

import "./FormSuratPengesahanPenunjukanPJO.vue?vue&type=style&index=0&id=0f6455ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f6455ba"]])

export default __exports__